import { ApiHelper } from 'shared/helpers/api';
import { getUrl, ROUTES } from 'shared/api/urls';
import { getDomain } from 'shared/helpers/app';
import { API_METHODS, METHODS } from 'shared/constants/api';

interface RewardsPageParams {
  countryCode?: string;
  fetchRewardsOffers?: boolean;
  fetchUserRewards?: boolean;
  lang?: string;
  customerId?: number;
}

interface RewardsPageRequest {
  params?: RewardsPageParams;
  headers: Partial<Record<string, string>>;
}

export const getRewardsPageData = ({ params = {}, headers }: RewardsPageRequest) => {
  const url = getUrl(ROUTES.VAULT_USER_DETAILS);

  const body = {
    customerId: params.customerId ? String(params.customerId) : null,
    domain: String(getDomain()) || 'FOOT_LOCKER',
  };

  const finalHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: '*/*',
    ...headers,
  };

  if (finalHeaders['Authorization']) {
    delete finalHeaders['Authorization'];
  }

  return ApiHelper(url, {
    method: API_METHODS[METHODS.POST],
    headers: finalHeaders,
    isBodyJSON: true,
    body,
  }).then((data) => {
    if (data.status !== 200) {
      return Promise.reject({ message: data.status });
    }
    return data.json();
  });
};
